class FlakesGenerator {
  constructor(cc) {
    this.resizeCanvasToDisplaySize(cc);
    this.ctx = cc.getContext('2d');
  }

  resizeCanvasToDisplaySize(canvas) {
    // look up the size the canvas is being displayed
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;

    // If it's resolution does not match change it
    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width;
      canvas.height = height;
      return true;
    }

    return false;
  }

  testate(amp, points) {
    const p = [];
    let i = points.length - 2,
      x1,
      y1,
      x2,
      y2;
    p.push((x1 = points[i++]));
    p.push((y1 = points[i]));
    i = 0;
    while (i < points.length) {
      x2 = points[i++];
      y2 = points[i++];
      const dx = x2 - x1;
      const dy = y2 - y1;
      const r = (Math.random() - 0.5) * 2 * amp;
      p.push(x1 + dx / 2 - dy * r);
      p.push(y1 + dy / 2 + dx * r);
      p.push((x1 = x2));
      p.push((y1 = y2));
    }
    return p;
  }

  drawFlake(size, x, y, noise) {
    const a = Math.random() * Math.PI;
    let points = [];
    const step = Math.PI * (2 / 3);
    let i = 0;
    while (i < 3) {
      const r = (Math.random() * size + size) / 2;
      points.push(Math.cos(a + i * step) * r);
      points.push(Math.sin(a + i * step) * r);
      i++;
    }
    while (size > 2) {
      points = this.testate(noise, points);
      size >>= 1;
    }
    i = 0;
    this.ctx.setTransform(1, 0, 0, 1, x, y);
    this.ctx.moveTo(points[i++], points[i++]);
    while (i < points.length) {
      this.ctx.lineTo(points[i++], points[i++]);
    }
  }
  drawRandomFlakes(count, col, min, max, noise) {
    this.ctx.fillStyle = col;
    this.ctx.beginPath();
    while (count-- > 0) {
      const x = Math.random() * this.ctx.canvas.width;
      const y = Math.random() * this.ctx.canvas.height;
      const size = min + Math.random() * (max - min);
      this.drawFlake(size, x, y, noise);
    }
    this.ctx.fill();
  }

  drawFlakes(groundColor, flakes) {
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx.fillStyle = groundColor;
    this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    const noise = Math.random() * 0.3 + 0.3;

    let amount = this.ctx.canvas.width * this.ctx.canvas.height * 0.01;

    for (let i = 0; i < flakes.length; i++) {
      let item = flakes[i];
      this.drawRandomFlakes(amount * (item.amount / 100), item.color.hex, 5, 7, noise);
    }
  }
}

export default FlakesGenerator;
